async function AddNode(userid, designid, node) {

    if (
        userid.length > 0 &&
        designid.length > 0 &&
        node.length > 0
    ) {

        let response;

        response = await fetch("https://api.cssi.co/CNF/addnode", {
            method: "POST",
            body: JSON.stringify(
                {
                    "userID": userid,
                    "designID": designid,
                    "node": node
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default AddNode;